export default {
  en: {
    'pages.account-settings.title': 'Account Settings',
    'pages.account-settings.sub-title': 'Your account information',
    'pages.account-settings.modify-email': 'Modify Email',
    'pages.account-settings.contact-support': 'Contact support',
    'pages.account-settings.send-request': 'Send a request via email to',
    'pages.account-settings.delete-account': 'Delete Account',
  },
};
